var _rect, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBgTestimonial = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 510,
    height: 338,
    viewBox: "0 0 510 338",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 510,
    height: 338,
    rx: 8,
    fill: "#8D0000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9703 98.1526C20.1337 91.9532 17 85.0002 17 73.7292C17 53.8959 30.923 36.1196 51.17 27.3306L56.2303 35.1392C37.332 45.3619 33.6373 58.6276 32.164 66.9916C35.207 65.4162 39.1907 64.8666 43.095 65.2292C53.3177 66.1756 61.3757 74.5679 61.3757 85.0002C61.3757 90.2604 59.2861 95.305 55.5666 99.0245C51.8471 102.744 46.8025 104.834 41.5423 104.834C35.462 104.834 29.648 102.057 25.9703 98.1526ZM82.637 98.1526C76.8003 91.9532 73.6667 85.0002 73.6667 73.7292C73.6667 53.8959 87.5897 36.1196 107.837 27.3306L112.897 35.1392C93.9987 45.3619 90.304 58.6276 88.8307 66.9916C91.8737 65.4162 95.8573 64.8666 99.7617 65.2292C109.984 66.1756 118.042 74.5679 118.042 85.0002C118.042 90.2604 115.953 95.305 112.233 99.0245C108.514 102.744 103.469 104.834 98.209 104.834C92.1287 104.834 86.3147 102.057 82.637 98.1526Z",
    fill: "#FBFBFB"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M484.03 239.848C489.866 246.047 493 253 493 264.271C493 284.104 479.077 301.881 458.83 310.67L453.77 302.861C472.668 292.638 476.363 279.373 477.836 271.009C474.793 272.584 470.809 273.134 466.905 272.771C456.682 271.825 448.624 263.432 448.624 253C448.624 247.74 450.714 242.695 454.433 238.976C458.153 235.256 463.198 233.167 468.458 233.167C474.538 233.167 480.352 235.943 484.03 239.848ZM427.363 239.848C433.2 246.047 436.333 253 436.333 264.271C436.333 284.104 422.41 301.881 402.163 310.67L397.103 302.861C416.001 292.638 419.696 279.373 421.169 271.009C418.126 272.584 414.143 273.134 410.238 272.771C400.016 271.825 391.963 263.432 391.963 253C391.963 247.74 394.053 242.695 397.772 238.976C401.492 235.256 406.537 233.167 411.797 233.167C417.877 233.167 423.691 235.943 427.369 239.848H427.363Z",
    fill: "#FBFBFB"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBgTestimonial);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bg-testimonial.9fe311c83e5916ce8dbce83c34fbae73.svg";